import React from 'react';
import PropTypes from 'prop-types';
import { Context } from '../../Context';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, Grid } from '@material-ui/core/';
import CampaignCardStyles from '../../Styles/CampaignCardStyles';
import { CalendarToday } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';

class CampaignCard extends React.Component {
	render() {
		const { classes } = this.props;
		const { campaign } = this.props;

		let budget = 'TBD';

		if (campaign.budget && campaign.budget.budget) {
			budget = campaign.budget.budget;
		}

		return (
			<div>
				<Link to={`/campaigns/${campaign._id}`} style={{ textDecoration: 'none' }}>
					<Paper className={classes.paper}>
						<Grid container spacing={0}>

							<Grid item xs={12}>
								<Grid container spacing={0}>
									<Grid item xs={8}>
										<Typography variant='h6' noWrap={true} gutterBottom>{campaign.name}</Typography>
										<Grid
											container
											direction="row"
											justify="flex-start"
											alignItems="center"
											spacing={0}
										>
											<Grid item xs={2}>
												<CalendarToday color='disabled' />
											</Grid>
											<Grid item xs={10}>
												<Typography variant='body2' color='textSecondary'>
													{campaign.goLiveDate ? (<Moment format='MMM Do [at] h:mmA'>
														{campaign.goLiveDate}
													</Moment>) : (<div>TBD</div>)}
												</Typography>
											</Grid>
										</Grid>
									</Grid>
									<Grid item xs={4}>
										<Typography variant='body2' gutterBottom align='right'>{campaign.status ? campaign.status : 'Draft'}</Typography>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={12} style={{ marginTop: 20 }}>
								<Typography variant='subtitle1' nowrap='true'>Budget: £{budget}</Typography>
							</Grid>
						</Grid>
					</Paper>
				</Link >
			</div >
		);
	}
}

CampaignCard.propTypes = {
	classes: PropTypes.object.isRequired
};

CampaignCard.contextType = Context;

export default withStyles(CampaignCardStyles)(CampaignCard);
